<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>
    Haben Sie zusätzliche Beschwerden weit weg vom Becken?<br />
    Zum Beispiel:
  </p>
  <ul class="list-disc ml-6">
    <li>Häufige Kopfschmerzen</li>
    <li>Verspannungen in der Schulter-Nacken-Region</li>
    <li>Bruxismus – Zähneknirschen und Zähnepressen</li>
  </ul>
</QuestionFrame>
